<template>
  <div :class="{'without_btn': hasPager}">

    <table-view
        :options="options"
        :isLoaded=isLoaded
        :listWithHeaderView="true"
        :isList=isMobile>

      <div slot="exportReport" slot-scope="props">
        <a href="#" @click.prevent="exportReport(props.row.id)">
          <mdc-icon icon="save_alt"></mdc-icon>
        </a>
      </div>
    </table-view>

  </div>
</template>

<script>
  import Manager from '../api/Manager';
  import {mapGetters, mapState} from 'vuex';
  import isEmpty from 'lodash/isEmpty';
  import Loader from '../../loader/components/Loader';
  import {pagination} from '../../../common/mixins/pagination';
  import lang from '../../../lang/translator';
  import TableView from '../../../common/table/components/TableView';
  import moment from 'moment';

  export default {
    data() {
      return {
        reports: [],
        isLoaded: true,
        sort: '-id',
        hasPager: false,
        options: {
          pageHeader: 'droReports',
          filterable: false,
          initialPage: null,
          sortable: [],
          skin: 'table table-sm table-with-head',
          columns: [
            {
              key: 'startedAt',
              changed: false,
              headings: lang.get('dro.report.started_at'),
            },
            {
              key: 'auditor',
              changed: false,
              headings: lang.get('dro.report.auditor'),
            },
            {
              key: 'behaviourDescription',
              changed: false,
              headings: lang.get('dro.report.behaviour_description'),
            },
            {
              key: 'intervalCount',
              changed: false,
              headings: lang.get('dro.report.interval_count'),
            },
            {
              key: 'successRate',
              changed: false,
              headings: lang.get('dro.report.success_rate'),
            },
            {
              key: 'failRate',
              changed: false,
              headings: lang.get('dro.report.fail_rate'),
            },
            {
              key: 'averageSuccessfulIntervalDuration',
              changed: false,
              headings: lang.get(
                  'dro.report.average_successful_interval_duration'),
            },
            {
              key: 'exportReport',
              changed: true,
              headings: lang.get('dro.report.download_report'),
            },
          ],
          listRow: {
            startedAt:
                {
                  headings: lang.get('dro.report.started_at'),
                  hasTemplate: true,
                },
            auditor:
                {
                  headings: lang.get('dro.report.auditor'),
                  hasTemplate: true,
                },
            behaviourDescription:
                {
                  headings: lang.get('dro.report.behaviour_description'),
                  hasTemplate: false,
                },
            intervalCount:
                {
                  headings: lang.get('dro.report.interval_count'),
                  hasTemplate: false,
                },
            successRate:
                {
                  headings: lang.get('dro.report.success_rate'),
                  hasTemplate: false,
                },
            failRate:
                {
                  headings: lang.get('dro.report.fail_rate'),
                  hasTemplate: false,
                },
            averageSuccessfulIntervalDuration:
                {
                  headings: lang.get(
                      'dro.report.average_successful_interval_duration'),
                  hasTemplate: false,
                },
            exportReport:
                {
                  headings: lang.get('dro.report.download_report'),
                  hasTemplate: false,
                },
          },
          templates: {
            startedAt: this.startedAt,
            auditor: this.auditor,
          },
          requestFunction: this.requestFunction,
          responseAdapter: function(resp) {
            return {
              data: resp.items,
              count: resp.total,
            };
          },
          texts: {
            filter: '',
            filterPlaceholder: lang.get(
                'user.type_the_therapist_name_to_search'),
            noResults: lang.get('bids.no_data'),
            loading: lang.get('home.labels.loading_message_table'),
          },
          columnsClasses: {
            startedAt: 'text-center',
            auditor: 'text-center',
            behaviourDescription: 'text-center',
            intervalCount: 'text-center',
            successRate: 'text-center',
            failRate: 'text-center',
            averageSuccessfulIntervalDuration: 'text-center',
            exportReport: 'text-center',
          },
          perPage: 10,
        },
      };
    },
    components: {Loader, TableView},
    mixins: [pagination],
    computed: {
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      isEmptyReports: function() {
        return isEmpty(this.reports);
      },
    },
    created() {
      //let assigneeId = this.route.params.clientId;
      //this.fetchReports(assigneeId, this.paginate.perPage, this.paginate.page);
    },
    methods: {

      toLocaleDateTime: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY HH:mm');
      },

      startedAt(h, row) {
        return this.toLocaleDateTime(row.startedAt.date);
      },

      auditor(h, row) {
        return row.auditor.name;
      },

      async requestFunction(data) {
        let assigneeId = this.route.params.clientId;
        return this.fetchReports(assigneeId, this.options.perPage, data.page);
      },
      fetchReports: async function(assigneeId, perPage, page) {
        try {
          this.isLoaded = false;
          localStorage.setItem('currentPage', page);
          localStorage.setItem('currentPageHeader', 'droReports');
          let response = await Manager.getReports(assigneeId, perPage, page);

          this.hasPager = response.data.data.lastPage > 1;

          this.reports = response.data.data.items.map((item) => {
            if (!item.behaviourDescription) {
              item.behaviourDescription = lang.get(
                  'export.reports.dro.not_specified');
            }
            return item;
          });
          this.setPaginate(response.data.data);
          this.isLoaded = true;

          return response.data.data;
        } catch (error) {
          console.dir(error);
          this.isLoaded = true;
        }
      },
      exportReport: async function(id) {
        try {
          let response = await Manager.exportReports(id).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'report_' + id + '.pdf');
            document.body.appendChild(link);
            link.click();
          });
        } catch (error) {
          console.dir(error);
        }
      },
      onPaginationClick(pageNum) {
        let assigneeId = this.route.params.clientId;
        this.fetchReports(assigneeId, this.paginate.perPage, pageNum);
        this.onPaginationBtnClick(pageNum);
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/dro/components/DroReport.vue